// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FeedbackMaxBot-module__mainBox--_38EG {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 24px 40px;
}

.FeedbackMaxBot-module__container--XI8Eb {
  width: 100%;
  max-width: 560px;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 20px;
  box-sizing: border-box;
}

.FeedbackMaxBot-module__title--URXts {
  width: 100%;
  text-align: center;
}

.FeedbackMaxBot-module__title--URXts h4 {
  margin: 30px 0 28px;

  color: #6f879c;
  font-size: 20px;
  line-height: 1.4;
  font-weight: 500;
}

.FeedbackMaxBot-module__boxImg--xcDtI {
  width: 260px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 28px;
}

.FeedbackMaxBot-module__boxImg--xcDtI img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.FeedbackMaxBot-module__feedbackBox--f2niN {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ---------- Rating ---------- */

.FeedbackMaxBot-module__ratingBlock--WUn5k {
  width: 270px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 28px;
}

.FeedbackMaxBot-module__rating--U3n7k {
  font-size: 52px !important;
}

.FeedbackMaxBot-module__rating--U3n7k .MuiRating-icon {
  margin: 0 2px;
}

.FeedbackMaxBot-module__rating--U3n7k .MuiRating-iconEmpty {
  color: #0054e647;
}

.FeedbackMaxBot-module__ratingLabels--O2YPS {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;

  margin-top: 8px;

  color: #6f879c;
  font-size: 12px;
  line-height: 1.3;
}

.FeedbackMaxBot-module__ratingLabels--O2YPS span:first-child {
  max-width: 105px;
  text-align: left;
}

.FeedbackMaxBot-module__ratingLabels--O2YPS span:last-child {
  max-width: 85px;
  text-align: right;
}

.FeedbackMaxBot-module__commentField--IGwY2 {
  width: 100%;
  margin-bottom: 20px;
}

.FeedbackMaxBot-module__commentField--IGwY2 .MuiOutlinedInput-root {
  border-radius: 4px;
  background-color: #fff;
}

.FeedbackMaxBot-module__commentField--IGwY2 .MuiOutlinedInput-root fieldset {
  border-color: #d5dadd;
}

.FeedbackMaxBot-module__commentField--IGwY2 .MuiOutlinedInput-root:hover fieldset {
  border-color: #9aaeba;
}

.FeedbackMaxBot-module__commentField--IGwY2 .MuiOutlinedInput-root.Mui-focused fieldset {
  border-color: #005bea;
  border-width: 1px;
}

.FeedbackMaxBot-module__commentField--IGwY2 .MuiInputBase-input {
  font-size: 15px;
  line-height: 1.5;
}

.FeedbackMaxBot-module__commentField--IGwY2 .MuiInputBase-input::placeholder {
  color: #9aaeba;
  opacity: 1;
}

.FeedbackMaxBot-module__btnBox--nYpbW {
    margin-top: 20px;
}
.FeedbackMaxBot-module__gradientButton--NsGd3 {
    width: 100%;
    max-width: 300px;
    height: 50px;
    margin-bottom: 15px;
    margin-top: 20px;
    border-radius: 25px;
    background: linear-gradient(90deg, #0051DF, #8DA8FF);
    color: white !important;
    font-weight: 600;
    border: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s;

    &:active {
        transform: scale(0.98);
    }
}
.FeedbackMaxBot-module__errorBox--XPM1c>p {
    color: #BD0048;
    font-size: 20px;
    font-weight: 500;
    margin-top: 50px;
}
.FeedbackMaxBot-module__successMessage--eMvYX {
    display: flex;
    flex-direction: column;
    color: green;
    font-size: 30px;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    margin-top: 90px;
}

.FeedbackMaxBot-module__successMessage--eMvYX>p {
    color: green;
    font-size: 26px;
    font-weight: bold;
    text-align: center;
}

.FeedbackMaxBot-module__successMessage--eMvYX>span>svg {
    color: green;
    font-size: 60px;
}
@media (max-width: 600px) {
  .FeedbackMaxBot-module__mainBox--_38EG {
    padding: 12px 16px 32px;
  }

  .FeedbackMaxBot-module__container--XI8Eb {
    max-width: 100%;
    padding: 12px 4px;
  }

  .FeedbackMaxBot-module__title--URXts h4 {
    margin: 24px 0 22px;
    font-size: 17px;
    line-height: 1.4;
  }

  .FeedbackMaxBot-module__boxImg--xcDtI {
    width: min(72vw, 240px);
    margin-bottom: 22px;
  }

  .FeedbackMaxBot-module__ratingBlock--WUn5k {
    width: 240px;
    margin-bottom: 24px;
  }

  .FeedbackMaxBot-module__rating--U3n7k {
    font-size: 43px;
  }

  .FeedbackMaxBot-module__rating--U3n7k .MuiRating-icon {
    margin: 0;
  }

  .FeedbackMaxBot-module__ratingLabels--O2YPS {
    font-size: 10px;
    gap: 10px;
  }

  .FeedbackMaxBot-module__ratingLabels--O2YPS span:first-child {
    max-width: 90px;
  }

  .FeedbackMaxBot-module__ratingLabels--O2YPS span:last-child {
    max-width: 75px;
  }

  .FeedbackMaxBot-module__commentField--IGwY2 {
    margin-bottom: 16px;
  }

  .FeedbackMaxBot-module__submitButton--PfgEQ {
    min-height: 46px;
    font-size: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/feedback-max-bot/FeedbackMaxBot.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;;EAEhB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;;EAEnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,iCAAiC;;AAEjC;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;;EAET,eAAe;;EAEf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,oDAAoD;IACpD,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;IACxC,0BAA0B;;IAE1B;QACI,sBAAsB;IAC1B;AACJ;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".mainBox {\r\n  min-height: 100vh;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  box-sizing: border-box;\r\n  padding: 20px 24px 40px;\r\n}\r\n\r\n.container {\r\n  width: 100%;\r\n  max-width: 560px;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.title {\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.title h4 {\r\n  margin: 30px 0 28px;\r\n\r\n  color: #6f879c;\r\n  font-size: 20px;\r\n  line-height: 1.4;\r\n  font-weight: 500;\r\n}\r\n\r\n.boxImg {\r\n  width: 260px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.boxImg img {\r\n  display: block;\r\n  width: 100%;\r\n  height: auto;\r\n  object-fit: contain;\r\n}\r\n\r\n.feedbackBox {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n/* ---------- Rating ---------- */\r\n\r\n.ratingBlock {\r\n  width: 270px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.rating {\r\n  font-size: 52px !important;\r\n}\r\n\r\n.rating :global(.MuiRating-icon) {\r\n  margin: 0 2px;\r\n}\r\n\r\n.rating :global(.MuiRating-iconEmpty) {\r\n  color: #0054e647;\r\n}\r\n\r\n.ratingLabels {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 20px;\r\n\r\n  margin-top: 8px;\r\n\r\n  color: #6f879c;\r\n  font-size: 12px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.ratingLabels span:first-child {\r\n  max-width: 105px;\r\n  text-align: left;\r\n}\r\n\r\n.ratingLabels span:last-child {\r\n  max-width: 85px;\r\n  text-align: right;\r\n}\r\n\r\n.commentField {\r\n  width: 100%;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.commentField :global(.MuiOutlinedInput-root) {\r\n  border-radius: 4px;\r\n  background-color: #fff;\r\n}\r\n\r\n.commentField :global(.MuiOutlinedInput-root fieldset) {\r\n  border-color: #d5dadd;\r\n}\r\n\r\n.commentField :global(.MuiOutlinedInput-root:hover fieldset) {\r\n  border-color: #9aaeba;\r\n}\r\n\r\n.commentField :global(.MuiOutlinedInput-root.Mui-focused fieldset) {\r\n  border-color: #005bea;\r\n  border-width: 1px;\r\n}\r\n\r\n.commentField :global(.MuiInputBase-input) {\r\n  font-size: 15px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.commentField :global(.MuiInputBase-input::placeholder) {\r\n  color: #9aaeba;\r\n  opacity: 1;\r\n}\r\n\r\n.btnBox {\r\n    margin-top: 20px;\r\n}\r\n.gradientButton {\r\n    width: 100%;\r\n    max-width: 300px;\r\n    height: 50px;\r\n    margin-bottom: 15px;\r\n    margin-top: 20px;\r\n    border-radius: 25px;\r\n    background: linear-gradient(90deg, #0051DF, #8DA8FF);\r\n    color: white !important;\r\n    font-weight: 600;\r\n    border: none;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    transition: transform 0.2s;\r\n\r\n    &:active {\r\n        transform: scale(0.98);\r\n    }\r\n}\r\n.errorBox>p {\r\n    color: #BD0048;\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    margin-top: 50px;\r\n}\r\n.successMessage {\r\n    display: flex;\r\n    flex-direction: column;\r\n    color: green;\r\n    font-size: 30px;\r\n    font-weight: bold;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 90px;\r\n}\r\n\r\n.successMessage>p {\r\n    color: green;\r\n    font-size: 26px;\r\n    font-weight: bold;\r\n    text-align: center;\r\n}\r\n\r\n.successMessage>span>svg {\r\n    color: green;\r\n    font-size: 60px;\r\n}\r\n@media (max-width: 600px) {\r\n  .mainBox {\r\n    padding: 12px 16px 32px;\r\n  }\r\n\r\n  .container {\r\n    max-width: 100%;\r\n    padding: 12px 4px;\r\n  }\r\n\r\n  .title h4 {\r\n    margin: 24px 0 22px;\r\n    font-size: 17px;\r\n    line-height: 1.4;\r\n  }\r\n\r\n  .boxImg {\r\n    width: min(72vw, 240px);\r\n    margin-bottom: 22px;\r\n  }\r\n\r\n  .ratingBlock {\r\n    width: 240px;\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .rating {\r\n    font-size: 43px;\r\n  }\r\n\r\n  .rating :global(.MuiRating-icon) {\r\n    margin: 0;\r\n  }\r\n\r\n  .ratingLabels {\r\n    font-size: 10px;\r\n    gap: 10px;\r\n  }\r\n\r\n  .ratingLabels span:first-child {\r\n    max-width: 90px;\r\n  }\r\n\r\n  .ratingLabels span:last-child {\r\n    max-width: 75px;\r\n  }\r\n\r\n  .commentField {\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .submitButton {\r\n    min-height: 46px;\r\n    font-size: 15px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainBox": `FeedbackMaxBot-module__mainBox--_38EG`,
	"container": `FeedbackMaxBot-module__container--XI8Eb`,
	"title": `FeedbackMaxBot-module__title--URXts`,
	"boxImg": `FeedbackMaxBot-module__boxImg--xcDtI`,
	"feedbackBox": `FeedbackMaxBot-module__feedbackBox--f2niN`,
	"ratingBlock": `FeedbackMaxBot-module__ratingBlock--WUn5k`,
	"rating": `FeedbackMaxBot-module__rating--U3n7k`,
	"ratingLabels": `FeedbackMaxBot-module__ratingLabels--O2YPS`,
	"commentField": `FeedbackMaxBot-module__commentField--IGwY2`,
	"btnBox": `FeedbackMaxBot-module__btnBox--nYpbW`,
	"gradientButton": `FeedbackMaxBot-module__gradientButton--NsGd3`,
	"errorBox": `FeedbackMaxBot-module__errorBox--XPM1c`,
	"successMessage": `FeedbackMaxBot-module__successMessage--eMvYX`,
	"submitButton": `FeedbackMaxBot-module__submitButton--PfgEQ`
};
export default ___CSS_LOADER_EXPORT___;
